import {
  doc,
  setDoc,
  onSnapshot,
  query,
  collection,
  orderBy,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { firestore, functions } from '../config/firebase';

const REQUESTS = 'personaApprovalRequests';

/**
 * @param {string} uid
 * @param {object} data
 */
export async function upsertPersonaApprovalRequest(uid, data) {
  if (!uid) throw new Error('uid required');
  const ref = doc(firestore, REQUESTS, uid);
  const now = new Date();
  await setDoc(
    ref,
    {
      uid,
      ...data,
      updatedAt: now,
      createdAt: data.createdAt || now,
    },
    { merge: true },
  );
}

/**
 * @param {(rows: object[]) => void} callback
 * @returns {() => void}
 */
export function subscribePendingPersonaApprovals(callback) {
  const q = query(collection(firestore, REQUESTS), orderBy('createdAt', 'desc'));
  return onSnapshot(
    q,
    (snap) => {
      callback(
        snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((row) => row.status === 'pending'),
      );
    },
    (err) => {
      console.error('subscribePendingPersonaApprovals', err);
      callback([]);
    },
  );
}

/**
 * @param {{ targetUid: string, approve: boolean, rejectionReason?: string }} params
 */
export async function reviewPersonaApproval(params) {
  const fn = httpsCallable(functions, 'reviewPersonaApproval');
  const result = await fn(params);
  return result.data;
}
